import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { $auth } from 'ziphy-web-shared/basic/entities/auth';
import { formatDate } from 'ziphy-web-shared/basic/utils/time';
import ChatMessageProvider from '@core/src/nedoShared/features/chat/components/ChatComponent/ui/ChatMessage/ChatMessageProvider/ChatMessageProvider';
import { SystemMessage } from '@nedoShared/features/chat/components/ChatComponent/ui/ChatMessage/SystemMessage/SystemMessage';
import styles from './styles.module.scss';
export const ProviderIntroChatMessage = ({ consultation, onActionClick }) => {
    const role = $auth.role.role;
    const isProvider = role === 'provider';
    const { t } = useTranslation();
    const { contentMessage, attachmentsMessage } = useMemo(() => {
        var _a, _b, _c, _d;
        if (!isProvider || !consultation)
            return { contentMessage: null, attachmentsMessage: null };
        const firstName = ((_a = consultation.patient) === null || _a === void 0 ? void 0 : _a.first_name) || '';
        const lastName = ((_b = consultation.patient) === null || _b === void 0 ? void 0 : _b.last_name) || '';
        const genderRaw = ((_c = consultation.patient) === null || _c === void 0 ? void 0 : _c.gender) || '';
        const gender = genderRaw ? genderRaw.charAt(0).toUpperCase() + genderRaw.slice(1) : '';
        const dobRaw = (_d = consultation.patient) === null || _d === void 0 ? void 0 : _d.dob;
        const dob = dobRaw ? formatDate(dobRaw, 'dateNum') : '';
        let ageYears = '';
        try {
            if (dobRaw) {
                const birth = new Date(dobRaw);
                const today = new Date();
                let years = today.getFullYear() - birth.getFullYear();
                const m = today.getMonth() - birth.getMonth();
                if (m < 0 || (m === 0 && today.getDate() < birth.getDate()))
                    years--;
                if (!isNaN(years))
                    ageYears = String(years);
            }
        }
        catch (e) { }
        const serviceTitle = consultation.service_title || '';
        const lines = [
            `**${firstName} ${lastName}**`,
            `${gender}${gender && (dob || ageYears) ? ', ' : ''}${dob}${dob && ageYears ? ` (Age ${ageYears})` : ageYears ? `(Age ${ageYears})` : ''}`,
            `**Service**`,
            `${serviceTitle}`,
            `**Order**`,
            `${consultation.number}`,
            // `**Reason**`,   //todo add Reason from initialIntake?
            // `Reason value`,
        ];
        const content = lines.join('\n');
        const base = {
            version: 0,
            created: consultation.created,
            modified: null,
            chat_id: consultation.chat_id,
            thread_id: '',
            role_id: 0,
        };
        const contentMessage = Object.assign(Object.assign({}, base), { _id: `intro-content-${consultation._id || '0'}`, content, attachments: [] });
        const attachmentsMessage = Object.assign(Object.assign({}, base), { _id: `intro-attachments-${consultation._id || '0'}`, content: '', attachments: [
                {
                    id: 'att-initial-intake',
                    upload_record_id: '',
                    created: consultation.created,
                    type: 'initial_intake',
                    content_type: 'application/json',
                },
                {
                    id: 'att-encounter',
                    upload_record_id: '',
                    created: consultation.created,
                    type: 'encounter',
                    content_type: 'application/json',
                },
            ] });
        return { contentMessage, attachmentsMessage };
    }, [isProvider, consultation]);
    if (!contentMessage && !attachmentsMessage)
        return null;
    return (_jsxs("div", Object.assign({ className: styles.chatProviderIntroMessage }, { children: [contentMessage && (_jsxs(_Fragment, { children: [_jsx(SystemMessage, { message: `${formatDate(consultation.created, 'dateFull')} ${t('label.order_created')}` }), _jsx("div", Object.assign({ style: { paddingTop: '8px' } }, { children: _jsx(ChatMessageProvider, { role: role, message: contentMessage, showTimestamp: true }) }))] })), attachmentsMessage && (_jsx(ChatMessageProvider, { role: role, message: attachmentsMessage, showTimestamp: true }))] })));
};
